var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "background" }, [
          _vm.loading
            ? _c("div", { staticClass: "text-center lds-circle" }, [_vm._m(0)])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.application.applicationStatus === _vm.ApplicationStatus.OFFERREJECTED
      ? _c("div", [
          _c(
            "h3",
            {
              staticClass: "text-center bold",
              staticStyle: { "margin-top": "50px" },
            },
            [_vm._v("You have rejected the offer for this job.")]
          ),
        ])
      : _vm.application.applicationStatus ===
        _vm.ApplicationStatus.OFFERACCEPTED
      ? _c("div", [
          _c(
            "h3",
            {
              staticClass: "text-center bold",
              staticStyle: { "margin-top": "50px" },
            },
            [
              _vm._v(
                "Congratulations! You have accepted the offer for this job."
              ),
            ]
          ),
        ])
      : _vm.application.applicationStatus === _vm.ApplicationStatus.OFFERSENT
      ? _c(
          "div",
          [
            _c(
              "md-card",
              [
                _c("div", { staticClass: "offer-header" }, [
                  _c(
                    "div",
                    { staticClass: "offer-info" },
                    [
                      _c("md-icon", [_vm._v(" domain ")]),
                      _c("h4", { staticClass: "offer-details-heading" }, [
                        _vm._v("Company Name"),
                      ]),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "offer-text" }, [
                    _vm._v(_vm._s(_vm.job.companyName)),
                  ]),
                ]),
                _c("md-divider"),
                _c(
                  "div",
                  {
                    staticClass: "w-full flex items-center justify-between",
                    staticStyle: { "flex-wrap": "wrap" },
                  },
                  [
                    _c("div", { staticClass: "offer-header" }, [
                      _c(
                        "div",
                        { staticClass: "offer-info" },
                        [
                          _c("md-icon", [_vm._v(" place ")]),
                          _c("h4", { staticClass: "offer-details-heading" }, [
                            _vm._v("Location"),
                          ]),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "offer-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.micro === null
                              ? "No Location"
                              : _vm.micro.location
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "offer-header" }, [
                      _c(
                        "div",
                        { staticClass: "offer-info" },
                        [
                          _c("md-icon", [_vm._v(" work ")]),
                          _c("h4", { staticClass: "offer-details-heading" }, [
                            _vm._v("Job Type"),
                          ]),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "offer-text" }, [
                        _vm._v(_vm._s(_vm.job.jobType)),
                      ]),
                    ]),
                    _c("div", { staticClass: "offer-header" }, [
                      _c(
                        "div",
                        { staticClass: "offer-info" },
                        [
                          _c("md-icon", [_vm._v(" paid ")]),
                          _c("h4", { staticClass: "offer-details-heading" }, [
                            _vm._v("Salary"),
                          ]),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "offer-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.job &&
                              _vm.job.offer &&
                              _vm.job.offer.monthlySalary
                              ? _vm.job.offer.monthlySalary
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "offer-header" }, [
                      _c(
                        "div",
                        { staticClass: "offer-info" },
                        [
                          _c("md-icon", [_vm._v(" event ")]),
                          _c("h4", { staticClass: "offer-details-heading" }, [
                            _vm._v("Start Date"),
                          ]),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "offer-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.job && _vm.job.offer && _vm.job.offer.startDate
                              ? _vm.job.offer.startDate
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "centre",
                    staticStyle: {
                      "text-align": "right",
                      "margin-right": "30px",
                      "margin-bottom": "30px",
                    },
                  },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        staticStyle: { "margin-right": "2rem" },
                        on: {
                          click: function ($event) {
                            _vm.acceptOfferModal = true
                          },
                        },
                      },
                      [_vm._v(" Accept Offer ")]
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger",
                        on: {
                          click: function ($event) {
                            _vm.rejectOfferModal = true
                          },
                        },
                      },
                      [_vm._v(" Reject Offer ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.acceptOfferModal
              ? _c("modal", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("h4", { staticClass: "modal-title" }, [
                              _vm._v("Accept Job Offer 🥳"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            !_vm.offerAccepted
                              ? _c("p", { staticClass: "modal-description" }, [
                                  _vm._v(
                                    "You are about to accept the job offer from " +
                                      _vm._s(_vm.job.companyName) +
                                      " for the postion: " +
                                      _vm._s(_vm.job.name)
                                  ),
                                ])
                              : _vm._e(),
                            _vm.offerAccepted
                              ? _c("p", { staticClass: "modal-description" }, [
                                  _vm._v(
                                    "Congratulations on accepting the job offer!"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "footer",
                        fn: function () {
                          return [
                            !_vm.offerAccepted
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-danger",
                                        staticStyle: { "margin-right": "1rem" },
                                        on: {
                                          click: function ($event) {
                                            _vm.acceptOfferModal = false
                                          },
                                        },
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-success",
                                        on: { click: _vm.acceptJobOffer },
                                      },
                                      [_vm._v("Accept")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.offerAccepted
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-success",
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmAcceptedOffer()
                                          },
                                        },
                                      },
                                      [_vm._v("Ok")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    341666436
                  ),
                })
              : _vm._e(),
            _vm.rejectOfferModal
              ? _c("modal", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            !_vm.rejectedOfferConfirmation
                              ? _c("h4", { staticClass: "modal-title" }, [
                                  _vm._v("Whoa there! 🤚"),
                                ])
                              : _vm._e(),
                            _vm.rejectedOfferConfirmation
                              ? _c("h4", [_vm._v("Offer Rejection")])
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            !_vm.rejectedOfferConfirmation
                              ? _c("p", { staticClass: "modal-description" }, [
                                  _vm._v(
                                    " You are about to reject the job offer from " +
                                      _vm._s(_vm.job.companyName) +
                                      " for the postion: " +
                                      _vm._s(_vm.job.name) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.rejectedOfferConfirmation
                              ? _c("p", { staticClass: "modal-description" }, [
                                  _vm._v(
                                    "Thank you for your reponse. We will be in touch with the employer's response."
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "footer",
                        fn: function () {
                          return [
                            !_vm.rejectedOfferConfirmation
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-danger",
                                        staticStyle: { "margin-right": "1rem" },
                                        on: {
                                          click: function ($event) {
                                            _vm.rejectOfferModal = false
                                          },
                                        },
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-success",
                                        on: { click: _vm.rejectJobOffer },
                                      },
                                      [_vm._v("Reject")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.rejectedOfferConfirmation
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass: "md-success",
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmRejection()
                                          },
                                        },
                                      },
                                      [_vm._v("Ok")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1636368586
                  ),
                })
              : _vm._e(),
            _vm.rejectOfferReasonModal
              ? _c(
                  "modal",
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c("h4", { staticClass: "modal-title black" }, [
                            _vm._v(
                              "Please specify the reasons for rejecting the offer"
                            ),
                          ]),
                          _vm.validationMessage !== ""
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { color: "red" },
                                },
                                [_vm._v(_vm._s(this.validationMessage))]
                              )
                            : _vm._e(),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-simple md-just-icon md-round modal-default-button",
                              on: { click: _vm.closeRejectOfferReasonModal },
                            },
                            [_c("md-icon", [_vm._v("clear")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "template",
                      { slot: "body" },
                      [
                        _c("md-table", {
                          attrs: { value: _vm.rejectionReasons, "md-card": "" },
                          on: { "md-selected": _vm.onSelect },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "md-table-row",
                                fn: function (ref) {
                                  var item = ref.item
                                  return _c(
                                    "md-table-row",
                                    { attrs: { "md-selectable": "multiple" } },
                                    [
                                      _c(
                                        "md-table-cell",
                                        { attrs: { "md-label": "Reasons" } },
                                        [_vm._v(" " + _vm._s(item.reason))]
                                      ),
                                    ],
                                    1
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            1006603314
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("template", { slot: "footer" }, [
                      _c(
                        "div",
                        {
                          staticClass: "centre",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-button md-danger",
                              on: { click: _vm.closeRejectOfferReasonModal },
                            },
                            [_vm._v(" Cancel")]
                          ),
                          _vm._v("        "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-button md-success",
                              on: { click: _vm.confirmDeclineModal },
                            },
                            [_vm._v(" Confirm")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm.emailError
              ? _c(
                  "modal",
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c("h4", { staticClass: "modal-title black" }, [
                            _vm._v("Whoops!😟"),
                          ]),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-simple md-just-icon md-round modal-default-button",
                              on: {
                                click: function ($event) {
                                  _vm.emailError = false
                                },
                              },
                            },
                            [_c("md-icon", [_vm._v("clear")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("template", { slot: "body" }, [
                      _c("p", [
                        _vm._v(
                          "An error occured, please refresh the page and try again or contact our Customer Success Team"
                        ),
                      ]),
                    ]),
                    _c("template", { slot: "footer" }, [
                      _c(
                        "div",
                        {
                          staticClass: "centre",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-button md-success",
                              on: {
                                click: function ($event) {
                                  _vm.emailError = false
                                },
                              },
                            },
                            [_vm._v(" Ok")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        )
      : _c("div", [
          _c(
            "h3",
            {
              staticClass: "text-center bold",
              staticStyle: { "margin-top": "50px" },
            },
            [_vm._v("You have no offer for this job yet.")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("@/assets/img/logo.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }